/**
 * @package admin
 */

import Criteria from '@shopware-ag/admin-extension-sdk/es/data/Criteria';

// eslint-disable-next-line sw-deprecation-rules/private-feature-declarations
export default Criteria;
